import React, { useContext, useEffect, useState } from 'react';
import { logger } from '../../common/logger';
import { request } from '../../common/request';
import LoadingIndicator from './LoadingIndicator';

export interface ILoadingContext {
  loading: boolean;
}

let loadingContext: React.Context<ILoadingContext>;

export function AppLoadingProvider({ children }: { children: React.ReactNode }) {
  const value = useProvideLoading();

  if (!loadingContext) {
    loadingContext = React.createContext<ILoadingContext>(value);
  }

  return <loadingContext.Provider value={value}>
    {
      children
    }
    <LoadingIndicator visible={value.loading} />
  </loadingContext.Provider>;
}

export const useLoading = () => {
  return useContext(loadingContext);
};

function useProvideLoading() {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const requestInterceptor = request.interceptors.request.use(req => {
      setLoading(true);
      return req;
    });

    const responseInterceptor = request.interceptors.response.use(
      res => {
        setLoading(false);
        return res;
      },
      error => {
        setLoading(false)
        throw error;
      }
    )

    logger.info('loading interceptors added');

    return () => {
      request.interceptors.request.eject(requestInterceptor);
      request.interceptors.response.eject(responseInterceptor);
    }
  }, []);

  return { loading };
}